import { render, staticRenderFns } from "./detailsSee.vue?vue&type=template&id=dde86ac8&scoped=true&"
import script from "./detailsSee.vue?vue&type=script&lang=js&"
export * from "./detailsSee.vue?vue&type=script&lang=js&"
import style0 from "./detailsSee.vue?vue&type=style&index=0&id=dde86ac8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde86ac8",
  null
  
)

export default component.exports